import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class ConsultApi extends WebApi {
    async fetchStoppagesEvents(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/stoppages`, payload);
        const { data } = await axios.get(url);
        return data.stoppages;
    }
    async postStoppageEvent(stoppage) {
        const { data } = await axios.post(`${this.urlPrefix}/stoppages`, { stoppage });
        return data.stoppage;
    }
    async updateStoppageEvent(id, stoppage) {
        const { data } = await axios.put(`${this.urlPrefix}/stoppages/${id}`, { stoppage });
        return data;
    }
    async deleteStoppageEvent(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/stoppages/${id}`);
        return data;
    }
}
const appointmentApi = new ConsultApi();
export { appointmentApi as ConsultApi, };
